import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { ChevronRight } from '@xsolla/ui-icons';

import { VerticalCenterBlock } from '../../../../styled';
import { StyledLink, Wrapper } from './featureStyle';

type Props = RouteComponentProps & {
  icon: React.ReactNode;
  text: string;
  link: string;
  onClose: () => void;
};

const FeatureCard = ({ icon, link, text, onClose, history }: Props) => {
  return (
    <Wrapper>
      {icon}
      <>
        <StyledLink
          onClick={() => {
            onClose();
            history.push(link);
          }}>
          <VerticalCenterBlock>
            {text} <ChevronRight />
          </VerticalCenterBlock>
        </StyledLink>
      </>
    </Wrapper>
  );
};

export default withRouter(FeatureCard);
